<template>
  <div>
    <title-edit header="Resource center" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" >
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_th" @update="updateTitleTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_en" @update="updateTitleEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.description_th" @update="updateDescriptionTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.description_en" @update="updateDescriptionEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Attached website</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.attached_website" @update="updateAttachedWebsite"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.slug_url" @update="updateSlugUrl"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slide Image :</label>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">
            <v-card @click="removeSlideImage(index)">
              <v-img
                :src="image.image_full_path"
                title="click for remove image"
                width="300px"
                height="150px"
              />
            </v-card>
          </v-col>
        </v-row>
        <input-image-upload
          id="image"
          menu="resource_center"
          @update="updateSlideImage"
          width="140px"
          height="140px"
        />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteResourceCenter" @save-info="saveResourceCenter" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
    import TitleEdit from "../../components/TitleHeader/TitleEdit";
    import LineHr from "../../components/Icon/line-hr";
    import SelectOption from "../../components/Input/selectOption";
    import InputTextField from "../../components/Input/InputTextField";
    import DeleteButton from "../../components/Button/DeleteButton";
    import PreviewButton from "../../components/Button/PreviewButton";
    import SaveButton from "../../components/Button/SaveButton";
    import InputEditor from "../../components/Input/InputEditor";
    import InputImageUpload from "../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    import DatePicker from "../../components/Input/DatePicker";
    import {permissionResourceCenter, role} from "../../util/Permission";
    import Swal from "sweetalert";
    import CommandButton from "../../components/Layout/CommandButton";

    export default {
        name: "ResourceCenterEdit",
      components: {
        CommandButton,
        DatePicker,
        InputImageUpload,
        InputEditor,
        SaveButton,
        PreviewButton, DeleteButton, InputTextField,
        SelectOption, LineHr, TitleEdit},
      computed: {
        permissionResourceCenter,
        ...mapState({
          form: state => {
            return state.ResourceCenter.form;
          }
        })
      },
      data(){
        return{
          optionBranch : [],
          permission : null,
          save_id: null
        }
      },
      created() {
        this.permission = role;
        this.getBranchData();
      },
      methods:{
        getBranchData() {
          this.$store.dispatch("Branch/getBranchAll").then(res => {
            this.optionBranch = [
              { text: "Select", value: "" },
              ...res.filter(val => val.branch_id !== 0).map(type => ({
                value: type.branch_id,
                text: type.branch_name_th + " (" + type.branch_name_en + ")"
              }))
            ];
          });
        },
        saveClose(){
          if (!this.form.title_th) {
            Swal('','Please insert Title TH !','error');
          } else if (!this.form.title_en) {
            Swal('','Please insert Title EN !','error');
          } else if (!this.form.description_th) {
            Swal('','Please insert Description TH !','error');
          } else if (!this.form.description_en) {
            Swal('','Please insert Description EN !','error');
          } else {
            this.$store
                    .dispatch("ResourceCenter/saveResourceCenter", {
                      id: this.save_id ? this.save_id : this.form.id,
                      data: this.form
                    })
                    .then(res => {
                      Swal(res.response_msg);
                      if (res.response_code == 200) {
                        this.goToResourceCenterTable();
                      }
                    })
                    .catch(() => {
                      Swal('', 'Cannot save Resource center data!', 'error');
                    });
          }
        },
        saveResourceCenter(){
          if (!this.form.title_th) {
            Swal('','Please insert Title TH !','error');
          } else if (!this.form.title_en) {
            Swal('','Please insert Title EN !','error');
          } else if (!this.form.description_th) {
            Swal('','Please insert Description TH !','error');
          } else if (!this.form.description_en) {
            Swal('','Please insert Description EN !','error');
          } else {
            this.$store
                    .dispatch("ResourceCenter/saveResourceCenter", {
                      id: this.save_id ? this.save_id : this.form.id,
                      data: this.form
                    })
                    .then(res => {
                      this.save_id = res.result.id;
                      Swal(res.response_msg);
                    })
                    .catch(() => {
                      Swal('', 'Cannot save Resource center data!', 'error');
                    });
          }
        },
        deleteResourceCenter(){
          this.$store
            .dispatch("ResourceCenter/deleteResourceCenter", this.form.id)
            .then(res => {
              Swal(res.response_msg);
              if (res.response_code == 200) {
                this.goToResourceCenterTable();
              }
            })
            .catch(() => {
              Swal('','Cannot delete Resource center','error');
            });
        },
        removeSlideImage(index){
          this.$store.dispatch("ResourceCenter/removeSlideImage", index);
        },
        updateSlideImage(val){
          let image_full_path = val.fullImagePath;
          let slide_image = val.imagePath;
          let data = {
            image_full_path,
            slide_image
          };
          this.$store.dispatch("ResourceCenter/insertSlideImage", data);
        },
        goToResourceCenterTable(){
          this.$router.push("/resource-center");
        },
        updateBranch(val){
          this.form.branch_id = val;
        },
        updateTitleTH(val){
          this.form.title_th = val;
        },
        updateTitleEN(val){
          this.form.title_en = val;
        },
        updateDescriptionTH(val){
          this.form.description_th = val;
        },
        updateDescriptionEN(val){
          this.form.description_en = val;
        },
        updateAttachedWebsite(val){
          this.form.attached_website = val;
        },
        updateSlugUrl(val){
          this.form.slug_url = val;
        }
      }
    }
</script>

<style lang="scss" scoped>

</style>
